import ContactPageIcon from "@mui/icons-material/ContactPage";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useLocation, useNavigate } from "react-router";
import logo from "../../assets/elegantHomeLogo.png";
import iconWeet from "../../assets/icon/egicon.png";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import BussinessSwapIcon from "../../assets/icon/Account.png";
import MarketSwapIcon from "../../assets/icon/marketSwitchIcon.png";
import SwitchIcon from "../../assets/img/icons/switch_icon-dash.png";
// import PersonIcon from '@mui/icons-material/Person';
import PlaceIcon from "@mui/icons-material/Place";
import { useEffect, useRef, useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { routePath } from "../../constants/routePath";
import Fav_Icon from "../../assets/icon/fac.png";
import Appointment_Icon from "../../assets/icon/apt.png";

import {
  setchangeRoll,
  setManualNavigation,
  setNavBarInputFields,
  setProfileTab,
  setSearchValue,
  setUserDetail,
} from "../../app/store/reducer";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { setSession, swalAlertPopProps } from "../../utils/commonUtils";
import { Place } from "@mui/icons-material";
import HomeIcon from "../../assets/Home.png";
import LoveIcon from "../../assets/Love.png";
import PersonIcon from "../../assets/Account.png";
import AlarmIcon from "../../assets/Alarm.png";
import { GetUserApi } from "../../utils/utils";
// import LogoutIcon from "../assets/img/icons/logout_icon.png";
import LogoutIcon from "../../assets/img/icons/logout_icon.png";
import LogOutPop from "../logoutPop";
import { useTheme } from "@emotion/react";
import Swal from "sweetalert2";
// import PersonIcon from "@mui/icons-material/Person";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
export const NavBar = (prop) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const manualNavRef = useRef(false);
  const navBarInputFields = useSelector(
    (state) => state.reducer.navBarInputFields,
  );
  const searchValue = useSelector((state) => state.reducer.searchValue);
  const [openLogout, setOpenLogout] = useState(false);

  const [open, setOpen] = useState(false);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const changeRoll = useSelector((state) => state.reducer.changeRoll);

  const [demoForm, setDemoForm] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
    phone: "",
    city: "",
  });

  const [errors, setErrors] = useState({});
  // .dropdown parlour

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElt, setAnchorElt] = useState(null);
  const opendrop = Boolean(anchorEl);
  // const [searchValue, setSearchValue] = useState('')
  const handleMenuOpen = (event) => {
    const isOnTargetPage = location.pathname === selectedOption.path;

    if (isOnTargetPage) {
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (path) => {
    navigate(path);
    setAnchorEl(null);
  };

  // const handleSearchClick = () => {
  //   if (selectedOption.path === routePath.JOBS) {
  //     navigate(routePath.JOBSLIST);
  //   } else {
  //     navigate(selectedOption.path);
  //   }
  // };
  const handleSearchClickOrType = (e) => {
    const isTypingEvent = e.type === "change";

    const isOnTargetPage =
      selectedOption.path === routePath.JOBS
        ? location.pathname === routePath.JOBSLIST
        : location.pathname === selectedOption.path;

    if (!isOnTargetPage && !isTypingEvent) {
      // Navigate if not on target page and this is a click
      if (selectedOption.path === routePath.JOBS) {
        navigate(routePath.JOBSLIST);
      } else {
        navigate(selectedOption.path);
      }
      return;
    }

    if (isTypingEvent) {
      // Handle typing
      dispatch(setSearchValue(e.target.value));
    }
  };

  const opent = Boolean(anchorElt);
  const handleMenuOpent = (event) => {
    setAnchorElt(event.currentTarget);
  };
  const handleMenuCloset = () => {
    setAnchorElt(null);
  };
  const serviceOptions = [
    { label: "Parlours", path: routePath.SERVICESLIST },
    { label: "Jobs", path: routePath.JOBS },
    { label: "Institute", path: routePath.COURSES },
    { label: "Franchise", path: routePath.FRANCHISE },
    { label: "White Label", path: routePath.WHITELABLESLIST },
  ];
 const selectedOption =
   serviceOptions.find((opt) => {
     if (opt.path === routePath.JOBS) {
       return (
         location.pathname === routePath.JOBS ||
         location.pathname === routePath.JOBSLIST
       );
     }

     if (opt.path === routePath.FRANCHISE) {
       return (
         location.pathname === routePath.FRANCHISE ||
         location.pathname.startsWith("/franchiseDetails")
       );
     }

     if (opt.path === routePath.COURSES) {
       return (
         location.pathname === routePath.COURSES ||
         location.pathname.startsWith("/coursedetails")
       );
     }
       if (opt.path === routePath.WHITELABLESLIST) {
         return location.pathname === routePath.WHITELABLESLIST;
       }

     return location.pathname === opt.path;
   }) || serviceOptions[0];


  // .dropdown parlour

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const isAssistantLogin = location.pathname === routePath.ASSISTANTLOGIN;
  const isAdminLogin = location.pathname === routePath.COMPANYUSELOGIN;
  const validate = () => {
    let temp = {};
    temp.name = formValues.name ? "" : "Name is required";
    temp.phone = /^[0-9]{10}$/.test(formValues.phone)
      ? ""
      : "Enter a Valid 10 digit phone number";
    temp.city = formValues.city ? "" : "City is required";

    setErrors(temp);
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmitForm = () => {
    if (validate()) {
      //console.log("Form Submitted:", formValues);

      const phoneNumber = "917721049949";
      // const phoneNumber = "917028399920";
      const message = `Hello, my name is ${formValues.name}. My mobile number is ${formValues.phone}, and I am from ${formValues.city}.
I would like to request a demo.`;
      const whatsappLink = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
        message,
      )}`;

      window.open(whatsappLink, "_blank");
      setDemoForm(false);
    }
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  useEffect(() => {
    //console.log("Current path:", location.pathname);
  }, [location.pathname]);

  // const handleSubmitForm = () => {
  // }
  const theme = useTheme();
  const is1440 = useMediaQuery("(min-width:1440px)");
  const is1200 = useMediaQuery("(min-width:1200px) and (max-width:1439.98px)");
  let searchBoxWidth = "100%"; // fallback

  if (is1440) {
    searchBoxWidth = "500px";
  } else if (is1200) {
    searchBoxWidth = "350px";
  }

  return (
    <>
      {!isAdminLogin && (
        <Box
          sx={{
            // backgroundColor: "#fff",
            boxShadow: "0 0 1rem 0px rgb(0 0 0 / 11%) !important",
            paddingY: "16px",
            background: "#E3DBFF",
          }}
        >
          <Grid
            container
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-between"
            alignItems="center"
            px={{ xs: "4px", sm: "20px" }}
          >
            <Grid item xs={9} sm={2} display="flex" justifyContent="start">
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  paddingLeft: { sm: "30px", xs: "0px" },
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  // width="65px"

                  component="img"
                  src={logo}
                  alt="logo"
                  onClick={() => {
                    if (userDetail.role === "Associate") return;
                    navigate(routePath.LANDINGPAGE);
                    sessionStorage.setItem("mode", "customer");
                    dispatch(setchangeRoll("customer"));
                  }}
                  sx={{
                    cursor: "pointer",
                    height: { sm: "48px", xs: "45px" },
                    textAlign: "left",
                  }}
                />
              </Box>
            </Grid>
            {/* <Grid item xs={12} sm={2} sx={{ display: { md: "block", xs: "none" } }}> */}

            {/* <TextField
            placeholder="Location"
            sx={{
              "& .MuiInputBase-input": {
                padding: "7.5px 10px !important",
                fontFamily: "Kanit",
              },
            }}
            value={prop?.navBarInputFields?.location}
            onClick={() => {
              prop.setLocationModal();
            }}
            fullWidth
          /> */}
            {/* </Grid> */}
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: { md: "block", xs: "none" } }}
            >
              {!isAssistantLogin &&
                location.pathname !== routePath.FAV &&
                location.pathname !== routePath.USERPROFILEC &&
                location.pathname !== routePath.OFFERS &&
                location.pathname !== routePath.ADVERTISEMENT &&
                location.pathname !== routePath.RECHARGE &&
                location.pathname !== routePath.REPORTSTAB &&
                location.pathname !== routePath.RECHARGEREPORT &&
                userDetail.role !== "Associate" && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: { md: "none", lg: "block", xs: "none" } }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        gap: 7,
                      }}
                    >
                      <Box
                        sx={{
                          display: { md: "flex", xs: "none" },
                          cursor: "pointer",
                          justifyContent: "end",
                        }}
                        onClick={() => {
                          prop.setLocationModal();
                        }}
                      >
                        <Typography component="span">
                          <PlaceIcon sx={{ color: "#be0b0c" }} />
                        </Typography>
                        <Typography>
                          <Typography
                            sx={{
                              color: "primary.main",
                              fontWeight: 500,
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            }}
                          >
                            Updated Location
                          </Typography>
                          <Typography
                            sx={{
                              color: "primary.main",
                              fontWeight: 700,
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            }}
                          >
                            {prop?.navBarInputFields?.location}
                          </Typography>
                        </Typography>
                      </Box>

                      {location.pathname !== routePath.LANDINGPAGE &&
                        location.pathname !== routePath.CUSTOMERLOGIN &&
                        location.pathname !== routePath.LOGIN && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              gap: 4,
                            }}
                          >
                            {/* Search */}

                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                boxShadow: "0px 4px 4px 0px #00000040",
                                borderRadius: "15px",
                                overflow: "hidden",
                                width: searchBoxWidth,
                              }}
                            >
                              {/* Dropdown Button */}
                              <Button
                                variant="contained"
                                onClick={handleMenuOpen}
                                endIcon={<ArrowDropDownIcon />}
                                sx={{
                                  borderTopLeftRadius: "14px",
                                  borderBottomLeftRadius: "14px",
                                  borderTopRightRadius: "0px",
                                  borderBottomRightRadius: "0px",
                                  padding: "8px 20px",
                                  fontWeight: 500,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {selectedOption.label}
                              </Button>

                              {/* Dropdown Menu */}
                              <Menu
                                anchorEl={anchorEl}
                                open={opendrop}
                                onClose={handleMenuClose}
                                MenuListProps={{ dense: true }}
                                PaperProps={{
                                  sx: {
                                    backgroundColor: "#01008B", // 🔥 MENU BACKGROUND
                                    // borderRadius: "12px",
                                    boxShadow: "0px 6px 20px rgba(0,0,0,0.2)",
                                  },
                                }}
                              >
                                {serviceOptions.map((option) => (
                                  <MenuItem
                                    key={option.path}
                                    selected={location.pathname === option.path}
                                    onClick={() => handleSelect(option.path)}
                                    sx={{
                                      color: "white",
                                      "&.Mui-selected": {
                                        backgroundColor: "#2423B2",
                                        color: "#FFFFFF",
                                        fontWeight: 600,
                                      },
                                    }}
                                  >
                                    {/* {//console.log(
                                    "locatcccc",
                                    location.pathname,
                                    "  ",
                                    option.path,
                                  )} */}
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Menu>

                              {/* Search Field */}
                              <TextField
                                placeholder={`Search ${selectedOption.label}...`}
                                fullWidth
                                InputProps={{
                                  endAdornment: (
                                    <SearchIcon
                                      sx={{ cursor: "pointer" }}
                                      // onClick={handleSearchClick}
                                    />
                                  ),
                                }}
                                sx={{
                                  backgroundColor: "#fff",
                                  "& .MuiInputBase-input": {
                                    padding: "7.5px 10px !important",
                                    fontFamily: "Kanit",
                                  },
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": { border: "none" },
                                    "&:hover fieldset": { border: "none" },
                                    "&.Mui-focused fieldset": {
                                      border: "none",
                                    },
                                    cursor: "pointer",
                                  },
                                  "& .MuiInputBase-input::placeholder": {
                                    color: "#585858",
                                    opacity: 1,
                                  },
                                }}
                                // onClick={handleSearchClick}
                                value={searchValue}
                                // onChange={(e) =>
                                //   dispatch(setSearchValue(e.target.value))
                                // }

                                onChange={(e) => handleSearchClickOrType(e)}
                                onClick={(e) => handleSearchClickOrType(e)}
                              />
                            </Box>
                          </Box>
                        )}
                    </Box>
                  </Grid>
                )}
            </Grid>
            {/* <Grid
            item
            xs={12}
            sm={2}
            display="flex"
            alignItems="center"
            justifyContent="end"
          >
            <Button
              onClick={() => navigate("/login")}
              className="mulish"
              variant="contained"
              color="primary"
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#3695B6 !important",
                borderRadius: "25px",
              }}
            >
              <ContactPageIcon sx={{ mr: 1 }} />
              Login
            </Button>
          </Grid> */}
            <Grid
              item
              xs={3}
              sm={3}
              display="flex"
              alignItems="center"
              justifyContent="end"
              gap={{
                md: 2,
                xs: 1,
              }}
            >
              {/* Home Icon */}
              {/* {location.pathname !== routePath.USERPROFILEC &&
                location.pathname !== routePath.OFFERS &&
                location.pathname !== routePath.ADVERTISEMENT &&
                location.pathname !== routePath.RECHARGE &&
                location.pathname !== routePath.REPORTSTAB &&
                location.pathname !== routePath.RECHARGEREPORT && (
                  <Tooltip title="Home">
                    <Box
                      sx={{ cursor: "pointer", width: "28px" }}
                      onClick={() => navigate(routePath.LANDINGPAGE)}
                    >
                      <Box
                        component="img"
                        src={HomeIcon}
                        alt="icon"
                        sx={{
                          width: {
                            xs: "25px",
                            md: "40px", 
                            lg: "100%", 
                          },
                          height: "auto", 
                        }}
                      />
                    </Box>
                  </Tooltip>
                )} */}

              {/* <Tooltip title="Add To Favorite">
            <Box
              sx={{ cursor: "pointer", width: "28px" }}
              onClick={() => navigate(routePath.FAV)}
            >
              <img src={LoveIcon} alt="icon" style={{ width: "100%" }} />
            </Box>
          </Tooltip> */}
              {location.pathname !== routePath.USERPROFILEC &&
                location.pathname !== routePath.OFFERS &&
                location.pathname !== routePath.ADVERTISEMENT &&
                location.pathname !== routePath.RECHARGE &&
                location.pathname !== routePath.REPORTSTAB &&
                location.pathname !== routePath.RECHARGEREPORT &&
                userDetail.role !== "Associate" && (
                  <Tooltip title="Notifications">
                    <Box
                      sx={{ cursor: "pointer", width: "28px" }}
                      // onClick={() => navigate(routePath.FAV)}
                    >
                      <Box
                        component="img"
                        src={AlarmIcon}
                        alt="icon"
                        sx={{
                          width: {
                            xs: "25px", // mobile
                            md: "40px", // medium screens
                            lg: "100%", // large screens
                          },
                          height: "auto", // keeps aspect ratio
                        }}
                      />
                      {/* <img src={AlarmIcon} alt="icon" style={{ width: "100%" }} /> */}
                    </Box>
                  </Tooltip>
                )}
              {/* {userDetail?.appMenu == "Biller" && (
            <Tooltip title="Change Role">
              <Box
                sx={{ cursor: "pointer", width: "28px" }}
                onClick={() => {
                  // navigate(routePath.FAV)
                  dispatch(setchangeRoll("dashboard"));
                  navigate(routePath.ADVERTICE);
                }}
              > 
                <img
                  src={BussinessSwapIcon}
                  alt="Icon"
                  style={{ width: "100%" }}
                />
              </Box>
            </Tooltip>
          )}  */}
              {/* .......Change role.................. */}
              {location.pathname !== routePath.USERPROFILEC &&
                location.pathname !== routePath.OFFERS &&
                location.pathname !== routePath.ADVERTISEMENT &&
                location.pathname !== routePath.RECHARGE &&
                location.pathname !== routePath.REPORTSTAB &&
                location.pathname !== routePath.RECHARGEREPORT &&
                userDetail.role !== "Associate" && (
                  <Tooltip title="Change Role">
                    <Box
                      sx={{
                        cursor: "pointer",
                        width: { sm: "120px", xs: "90px" },
                      }}
                      onClick={async () => {
                        sessionStorage.setItem("mode", "dashboard");
                        dispatch(setchangeRoll("dashboard"));

                        const token = sessionStorage.getItem("smbToken");
                        if (location.pathname === routePath.LOGIN) {
                          navigate(routePath.LANDINGPAGE);
                          return;
                        }

                        if (!token) {
                          navigate(routePath.LOGIN);
                          return;
                        }

                        try {
                          const userResponse = await GetUserApi();
                          const userData = userResponse?.data?.data;

                          if (userData?.appMenu === "Biller") {
                            navigate(routePath.DASHBOARD);
                          } else {
                            Swal.fire({
                              text: "You are not a biller sign up as a biller before changing role",
                              icon: "warning",
                              ...swalAlertPopProps,
                            });
                            navigate(routePath.LOGIN);
                          }
                        } catch (error) {
                          console.error("Change role error:", error);
                          navigate(routePath.LOGIN);
                        }
                      }}
                    >
                      {/* <SwapHorizIcon /> */}
                      {/* <Box
                        component="img"
                        src={
                          location.pathname === routePath.LOGIN
                            ? MarketSwapIcon
                            : location.pathname === routePath.DASHBOARD
                              ? MarketSwapIcon
                              : BussinessSwapIcon
                        }
                        alt="icon"
                        sx={{
                          width: {
                            xs: "25px", // mobile
                            md: "40px", // medium screens
                            lg: "100%", // large screens
                          },
                          height: "auto", // keeps aspect ratio
                        }}
                      /> */}
                      <Button
                        variant="contained"
                        disableElevation
                        sx={{
                          background:
                            "linear-gradient(90deg, #3f00b5 0%, #9c00af 50%, #f500a2 100%)",
                          borderRadius: "50px",
                          py:
                            location.pathname === routePath.LOGIN
                              ? { xs: "8px", sm: "8px" }
                              : location.pathname === routePath.DASHBOARD
                                ? { xs: "12px", sm: "8px" }
                                : { xs: "0px", sm: "8px" },
                          px: "14px",
                          textTransform: "none",
                          fontSize: { xs: "8px", sm: "8px", md: "12px" },

                          fontWeight: 700,
                          fontFamily:
                            '"Roboto", "Helvetica", "Arial", sans-serif',
                          color: "#ffffff",
                          "&:hover": {
                            background:
                              "linear-gradient(90deg, #320091 0%, #7d008c 50%, #c40082 100%)",
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                          },
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        {location.pathname === routePath.LOGIN
                          ? "MarketPlace"
                          : location.pathname === routePath.DASHBOARD
                            ? "MarketPlace"
                            : "Business Login"}
                      </Button>
                    </Box>
                  </Tooltip>
                )}

              {/* ................... */}
              {location.pathname !== routePath.USERPROFILEC &&
                location.pathname !== routePath.OFFERS &&
                location.pathname !== routePath.ADVERTISEMENT &&
                location.pathname !== routePath.RECHARGE &&
                location.pathname !== routePath.REPORTSTAB &&
                location.pathname !== routePath.RECHARGEREPORT &&
                userDetail.role !== "Associate" && (
                  <>
                    <IconButton
                      sx={{
                        cursor: "pointer",
                        width: { sm: "0px", xs: "0px" },
                      }}
                      onClick={handleMenuOpent}
                    >
                      <MenuIcon sx={{ fontSize: "32px" }} />
                    </IconButton>

                    {/* ✅ Dropdown Menu */}
                    <Menu
                      anchorEl={anchorElt}
                      open={opent}
                      onClose={handleMenuCloset}
                      PaperProps={{
                        sx: {
                          width: 250,
                          borderRadius: "12px",
                          mt: 1,
                          boxShadow: 4,
                        },
                      }}
                    >
                      {/* ✅ Favourite Link */}
                      <MenuItem
                        onClick={async () => {
                          try {
                            dispatch(setManualNavigation(true));
                            dispatch(setchangeRoll(null));
                            //console.log("userDetail ", userDetail);
                            await setSession("nextPage", "USERPROFILE");
                            const token = sessionStorage.getItem("smbToken");
                            if (!token) {
                              navigate(routePath.CUSTOMERLOGIN);
                              return;
                            }
                            const userResponse = await GetUserApi();
                            if (userResponse?.data?.data) {
                              dispatch(setUserDetail(userResponse.data.data));
                              navigate(routePath.FAV); // only navigate once
                            } else {
                              navigate(routePath.CUSTOMERLOGIN);
                            }
                          } catch (error) {
                            console.error("Profile click error:", error);
                            navigate(routePath.CUSTOMERLOGIN);
                          } finally {
                            manualNavRef.current = false;
                          }
                          handleMenuCloset();
                          console.log("click to login");
                        }}
                        sx={{
                          fontWeight: 600,
                          color: "#3D3D3D",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          gap: 2,
                        }}
                      >
                        <Box
                          component="img"
                          src={PersonIcon}
                          alt="icon"
                          sx={{
                            width: {
                              xs: "25px",
                              md: "28px",
                              lg: "30px",
                            },
                            height: "auto", // keeps aspect ratio
                          }}
                        />
                        My Profile
                      </MenuItem>

                      <MenuItem
                        sx={{
                          fontWeight: 600,
                          color: "#3D3D3D",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          gap: 2,
                        }}
                        onClick={async () => {
                          dispatch(setManualNavigation(true));
                          dispatch(setchangeRoll(null));
                          //console.log("userDetail ", userDetail);
                          await setSession("nextPage", "USERPROFILE");
                          const token = sessionStorage.getItem("smbToken");
                          if (!token) {
                            navigate(routePath.CUSTOMERLOGIN);
                            return;
                          }
                          dispatch(setProfileTab("favorites"));
                          navigate(routePath.FAV);
                          handleMenuCloset();
                        }}
                      >
                        <Box
                          component="img"
                          src={Fav_Icon}
                          alt="icon"
                          sx={{
                            width: {
                              xs: "25px",
                              md: "28px",
                              lg: "30px",
                            },
                            height: "auto", // keeps aspect ratio
                          }}
                        />
                        My Favourites
                      </MenuItem>

                      <MenuItem
                        sx={{
                          fontWeight: 600,
                          color: "#3D3D3D",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          gap: 2,
                        }}
                        onClick={async () => {
                          dispatch(setManualNavigation(true));
                          dispatch(setchangeRoll(null));
                          //console.log("userDetail ", userDetail);
                          await setSession("nextPage", "USERPROFILE");
                          const token = sessionStorage.getItem("smbToken");
                          if (!token) {
                            navigate(routePath.CUSTOMERLOGIN);
                            return;
                          }
                          dispatch(setProfileTab("appointments"));
                          navigate(routePath.FAV);
                          handleMenuCloset();
                        }}
                      >
                        {" "}
                        <Box
                          component="img"
                          src={Appointment_Icon}
                          alt="icon"
                          sx={{
                            width: {
                              xs: "25px",
                              md: "28px",
                              lg: "30px",
                            },
                            height: "auto", // keeps aspect ratio
                          }}
                        />
                        My Appointments
                      </MenuItem>
                    </Menu>
                  </>
                )}
              {/* ...................... */}
              {/* {location.pathname !== routePath.USERPROFILEC &&
                location.pathname !== routePath.OFFERS &&
                location.pathname !== routePath.ADVERTISEMENT &&
                location.pathname !== routePath.RECHARGE &&
                location.pathname !== routePath.REPORTSTAB &&
                location.pathname !== routePath.RECHARGEREPORT && (
                  <Box
                    sx={{ cursor: "pointer", width: "28px" }}
                    onClick={async () => {
                      try {
                        dispatch(setManualNavigation(true));
                        dispatch(setchangeRoll(null));
                        //console.log("userDetail ", userDetail);
                        await setSession("nextPage", "USERPROFILE");
                        const token = sessionStorage.getItem("smbToken");
                        if (!token) {
                          navigate(routePath.CUSTOMERLOGIN);
                          return;
                        }
                        const userResponse = await GetUserApi();
                        if (userResponse?.data?.data) {
                          dispatch(setUserDetail(userResponse.data.data));
                          navigate(routePath.FAV); // only navigate once
                        } else {
                          navigate(routePath.CUSTOMERLOGIN);
                        }
                      } catch (error) {
                        console.error("Profile click error:", error);
                        navigate(routePath.CUSTOMERLOGIN);
                      } finally {
                        manualNavRef.current = false;
                      }

                      console.log("click to login");
                    }}
                  >
                    <Box
                      component="img"
                      src={PersonIcon}
                      alt="icon"
                      sx={{
                        width: {
                          xs: "25px", // mobile
                          md: "40px", // medium screens
                          lg: "100%", // large screens
                        },
                        height: "auto", // keeps aspect ratio
                      }}
                    />
                 </Box>
                )} */}

              {(changeRoll === "admin" || userDetail.role === "Associate") && (
                <Box
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    setOpenLogout(true);
                  }}
                >
                  <img src={LogoutIcon} alt="LogoutIcon" height={40} />
                </Box>
              )}
              <LogOutPop open={openLogout} setOpen={setOpenLogout} />

              {location.pathname === routePath.USERPROFILE && (
                <Button
                  sx={{ display: "flex" }}
                  variant="contained"
                  color="primary"
                  endIcon={<AccountCircleIcon />}
                  onClick={async () => {
                    //console.log("userDetail ", userDetail);
                    // if (!userDetail || Object.keys(userDetail).length == 0) {
                    //   navigate(routePath.LOGIN);
                    // } else {
                    //   navigate(routePath.USERPROFILE);
                    // }
                    await sessionStorage.clear();
                    await sessionStorage.clear();
                    navigate(routePath.LOGIN);
                    dispatch(setUserDetail({}));
                    // toggleDrawer(true);
                  }}
                >
                  Log out
                </Button>
              )}
            </Grid>

            {/* : { md: "block", xs: "block", lg: "none" }  */}
            {location.pathname !== routePath.USERPROFILEC &&
              location.pathname !== routePath.OFFERS &&
              location.pathname !== routePath.ADVERTISEMENT &&
              location.pathname !== routePath.RECHARGE &&
              location.pathname !== routePath.REPORTSTAB &&
              location.pathname !== routePath.FAV &&
              location.pathname !== routePath.RECHARGEREPORT &&
              location.pathname !== routePath.LOGIN &&
              location.pathname !== routePath.CUSTOMERLOGIN &&
              location.pathname !== routePath.ASSISTANTLOGIN &&
              userDetail.role !== "Associate" && (
                <Grid
                  item
                  xs={12}
                  sx={{ display: { md: "block", xs: "block", lg: "none" } }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: { lg: 7, md: 7, sm: 4, xs: 2 },
                    }}
                  >
                    <Box
                      sx={{
                        display: { md: "flex", xs: "flex", lg: "none" },
                        cursor: "pointer",
                        justifyContent: "end",
                      }}
                      onClick={() => {
                        prop.setLocationModal();
                      }}
                    >
                      <Typography component="span">
                        <PlaceIcon sx={{ color: "#be0b0c" }} />
                      </Typography>
                      <Typography>
                        <Typography
                          sx={{
                            color: "primary.main",
                            fontWeight: 500,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Updated Location
                        </Typography>
                        <Typography
                          sx={{
                            color: "primary.main",
                            fontWeight: 700,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          {prop?.navBarInputFields?.location}
                        </Typography>
                      </Typography>
                    </Box>

                    {/* ..dropdwon search  md: "block", lg: "none", xs: "block"*/}
                    {location.pathname !== routePath.LANDINGPAGE && (
                      <Grid
                        item
                        xs={6}
                        lg={6}
                        md={6}
                        sm={4}
                        sx={{
                          display: { md: "block", lg: "none", xs: "none" },
                        }}
                      >
                        {
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              gap: 4,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                boxShadow: "0px 4px 4px 0px #00000040",
                                borderRadius: "15px",
                                overflow: "hidden",
                                width: searchBoxWidth,
                              }}
                            >
                              {/* Dropdown Button */}
                              <Button
                                variant="contained"
                                onClick={handleMenuOpen}
                                endIcon={<ArrowDropDownIcon />}
                                sx={{
                                  borderTopLeftRadius: "14px",
                                  borderBottomLeftRadius: "14px",
                                  borderTopRightRadius: "0px",
                                  borderBottomRightRadius: "0px",
                                  padding: "8px 20px",
                                  fontWeight: 500,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {selectedOption.label}
                              </Button>

                              {/* Dropdown Menu */}
                              <Menu
                                anchorEl={anchorEl}
                                open={opendrop}
                                onClose={handleMenuClose}
                                MenuListProps={{ dense: true }}
                                PaperProps={{
                                  sx: {
                                    backgroundColor: "#01008B", // 🔥 MENU BACKGROUND
                                    // borderRadius: "12px",
                                    boxShadow: "0px 6px 20px rgba(0,0,0,0.2)",
                                  },
                                }}
                              >
                                {serviceOptions.map((option) => (
                                  <MenuItem
                                    key={option.path}
                                    selected={location.pathname === option.path}
                                    onClick={() => handleSelect(option.path)}
                                    sx={{
                                      color: "white",
                                      "&.Mui-selected": {
                                        backgroundColor: "#2423B2",
                                        color: "#FFFFFF",
                                        fontWeight: 600,
                                      },
                                    }}
                                  >
                                    {/* {//console.log(
                                      "locatcccc",
                                      location.pathname,
                                      "  ",
                                      option.path,
                                    )} */}
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Menu>

                              {/* Search Field */}
                              <TextField
                                placeholder={`Search ${selectedOption.label}...`}
                                fullWidth
                                InputProps={{
                                  endAdornment: (
                                    <SearchIcon
                                      sx={{ cursor: "pointer" }}
                                      // onClick={handleSearchClick}
                                    />
                                  ),
                                }}
                                sx={{
                                  backgroundColor: "#fff",
                                  "& .MuiInputBase-input": {
                                    padding: "7.5px 10px !important",
                                    fontFamily: "Kanit",
                                  },
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": { border: "none" },
                                    "&:hover fieldset": { border: "none" },
                                    "&.Mui-focused fieldset": {
                                      border: "none",
                                    },
                                    cursor: "pointer",
                                  },
                                  "& .MuiInputBase-input::placeholder": {
                                    color: "#585858",
                                    opacity: 1,
                                  },
                                }}
                                // onClick={handleSearchClick}
                                value={searchValue}
                                // onChange={(e) => {
                                //   // this ALWAYS works
                                //   dispatch(setSearchValue(e.target.value));
                                // }}
                                onChange={(e) => handleSearchClickOrType(e)}
                                onClick={(e) => handleSearchClickOrType(e)}
                              />
                            </Box>
                          </Box>
                        }
                      </Grid>
                    )}
                    {/* Mobile Request Demo Button */}

                    <Box
                      sx={{
                        display: {
                          xs: "flex",
                          md: "flex",
                          sm: "flex",
                          lg: "none",
                        },
                        justifyContent: "center",
                        mt: 2,
                      }}
                    >
                      <Button
                        sx={{
                          borderRadius: "20px",
                          padding: "8px 20px",
                          fontWeight: 600,
                          textTransform: "none",
                          color: "white",
                          fontSize: { xs: "10px", sm: "12px", md: "15px" },

                          background: "oklch(66.6% 0.179 58.318)",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            background: "oklch(66.6% 0.179 58.318)",
                            boxShadow: "0 6px 16px rgba(0,0,0,0.3)",
                          },
                        }}
                        onClick={() => setDemoForm(true)}
                      >
                        Request Demo
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              )}
          </Grid>
          <Drawer anchor="top" open={open} onClose={toggleDrawer(false)}>
            <Box display={"flex"} flexDirection={"column"} gap={3} p={3}>
              <TextField
                placeholder="Location"
                sx={{
                  "& .MuiInputBase-input": {
                    padding: "7.5px 10px !important",
                    fontFamily: "Kanit",
                  },
                }}
                value={prop?.navBarInputFields?.location}
                onClick={() => {
                  prop.setLocationModal();
                }}
                fullWidth
              />
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <TextField
                  placeholder="Search Services / Products"
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "7.5px 10px !important",
                      fontFamily: "Kanit",
                    },
                  }}
                  value={navBarInputFields.bussiness}
                  onChange={(e) =>
                    dispatch(
                      setNavBarInputFields({ bussiness: e.target.value }),
                    )
                  }
                />
                {location.pathname === "/home" && (
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      backgroundColor: "#3695B6 !important",
                      borderRadius: "25px",
                      mx: 2,
                    }}
                    onClick={() => {
                      if (navBarInputFields.bussiness?.trim() != "") {
                        navigate(routePath.SERVICESLIST);
                      }
                    }}
                    startIcon={<SearchIcon />}
                  >
                    Search
                  </Button>
                )}
              </Box>
            </Box>
            <Button
              variant="contained"
              color="primary"
              endIcon={<CloseIcon />}
              onClick={toggleDrawer(false)}
              sx={{ borderRadius: "0" }}
            >
              Close
            </Button>
          </Drawer>

          <Dialog open={demoForm} onClose={() => setDemoForm(false)}>
            <DialogTitle>
              Book Your Demo
              <IconButton
                aria-label="close"
                onClick={() => {
                  setDemoForm(false);
                  setFormValues({
                    name: "",
                    phone: "",
                    city: "",
                  });
                  // setErrors({});
                }}
                sx={{
                  position: "absolute",
                  right: 12,
                  top: 8,
                }}
              >
                <CloseIcon sx={{ fontSize: "30px" }} />
              </IconButton>
            </DialogTitle>

            <DialogContent>
              <TextField
                name="name"
                value={formValues.name}
                onChange={handleChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // only letters + spaces
                }}
                fullWidth
                size="small"
                label="Name:"
                margin="dense"
                required
                error={!!errors.name}
                helperText={errors.name}
                InputLabelProps={{
                  sx: {
                    fontSize: { xs: "13px", sm: "14px", md: "15px" },

                    "& .MuiFormLabel-asterisk": {
                      color: "red",
                    },
                  },
                }}
              />
              <TextField
                name="phone"
                value={formValues.phone}
                onChange={handleChange}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/\D/g, "")
                    .slice(0, 10);
                }}
                fullWidth
                size="small"
                label="Phone Number:"
                margin="dense"
                required
                error={!!errors.phone}
                helperText={errors.phone}
                InputLabelProps={{
                  sx: {
                    fontSize: { xs: "13px", sm: "14px", md: "15px" },

                    "& .MuiFormLabel-asterisk": {
                      color: "red",
                    },
                  },
                }}
              />
              <TextField
                name="city"
                value={formValues.city}
                onChange={handleChange}
                fullWidth
                size="small"
                label="City:"
                margin="dense"
                required
                error={!!errors.city}
                helperText={errors.city}
                InputLabelProps={{
                  sx: {
                    fontSize: { xs: "13px", sm: "14px", md: "15px" },

                    "& .MuiFormLabel-asterisk": {
                      color: "red",
                    },
                  },
                }}
              />
            </DialogContent>

            <DialogActions
              sx={{
                justifyContent: "center",
                p: 2,
                borderTop: "1px solid #000000",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "oklch(66.6% 0.179 58.318)",
                  "&:hover": { backgroundColor: "oklch(66.6% 0.179 58.318)" },
                  borderRadius: "4px",
                  fontWeight: 600,
                  textTransform: "none",
                  px: 3,
                }}
                onClick={handleSubmitForm}
              >
                Send Request
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      )}
    </>
  );
};
